import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
  reports: {},
}

export const getters = {}

export const mutations = {
  REPORTS(state, request) {
    state.reports = request
  },
}


export const actions = {
  init({ state, dispatch }) { },

  fetchParticipantsExcel(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/api/excel/participants/download/`, {
        responseType: 'blob',
      })
  },

  fetchParticipantsExcelTemplate(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/api/excel/participants/download_template/`, {
        responseType: 'blob',
      })
  },

  SubmitParticipantsExcel(context, payload) {
    let promise = axios.post(`${serverUrl}/api/excel/participants/${payload.scheduleId}/upload_excel/`, payload.form)
    return promise.then(
      (response) => {
        return response
      }
    )

  },

  fetchBudgetExcel(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/api/excel/budget/download/`, {
        responseType: 'blob',
      })
  },
}
